import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function WhatIsIt() {
  return <section className="border-t border-ink-950/8 bg-canvas py-20 lg:py-28" data-id="element-172" data-mp="2ki55op5i3akl">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-173" data-mp="25vbx02qhl31d">
        <div className="grid gap-12 lg:grid-cols-[1.15fr_0.85fr] lg:gap-20" data-id="element-174" data-mp="25spp21zoolim">
          <div data-id="element-175" data-mp="2arsmp1dc3pgk">
            <p className="mb-4 text-xs uppercase tracking-[0.18em] text-aqua-600" data-id="element-176" data-mp="2araf58l81otc">
              What it is
            </p>
            <h2 className="max-w-2xl font-display text-3xl font-semibold leading-[1.08] tracking-tightest text-ink-950 sm:text-4xl lg:text-[46px]" data-id="element-177" data-mp="20v7i2h588gd9">
              Not a better filter. Not a better chlorine. The end of chlorine.
            </h2>

            <div className="mt-8 max-w-xl space-y-5 text-[17px] leading-relaxed text-ink-700" data-id="element-178" data-mp="1rvaw4na81vlw">
              <p data-id="element-179" data-mp="3ha8odja584bw">
                Hydrosprings systems are built on{' '}
                <strong className="font-medium text-ink-950" data-id="element-180" data-mp="3m925dlon2dgt">Fusion 44X</strong>
                , the world&rsquo;s first true 100% chemical-free pool system,
                designed to purify water without chlorine, salt or harmful
                additives.
              </p>
              <p data-id="element-181" data-mp="30aoramllcxew">
                It uses a breakthrough process called{' '}
                <strong className="font-medium text-ink-950" data-id="element-182" data-mp="30crhp7qnosk5">
                  Hydro-pH-Infusion
                </strong>
                , which balances pH between 7.2 and 7.6 and eliminates algae and
                bacteria by infusing the water with electrically charged
                hydrogen &mdash; creating water so safe it meets EPA
                drinking-water standards.
              </p>
              <p data-id="element-183" data-mp="2hi2sbtfe0qq3">
                It replaces decades of toxic pool treatment with a safe,
                natural, science-backed solution &mdash; proprietary Fusion 44X
                technology, backed by patented innovation, confidential process
                engineering, and independent scientific study.
              </p>
            </div>

            <Link to="/technology" className="group mt-9 inline-flex items-center gap-2 text-sm font-medium text-ink-950 transition-colors duration-150 ease-smooth hover:text-aqua-700" data-id="element-184" data-mp="2lmbh95zsl7zt">
              Read the science
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-185" data-mp="2zmm9accu8smk" />
            </Link>
          </div>

          <div className="flex flex-col gap-6" data-id="element-186" data-mp="26xfe9nclel62">
            <figure className="overflow-hidden rounded-2xl" data-id="element-187" data-mp="26w4avon27ffh">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/585504d6-3177-4284-bf1d-b354b86ae99c.jpg" alt="A glass of clear water at the edge of a pool with fine hydrogen bubbles rising" className="aspect-square w-full object-cover" loading="lazy" data-id="element-188" data-mp="2bw8o95so7u1h" />
              <figcaption className="mt-3 text-[13px] text-ink-600" data-id="element-189" data-mp="1o5cu420qsmr2">
                Can you drink your pool water? Ours meets the standard.
              </figcaption>
            </figure>
            <blockquote className="rounded-2xl bg-aqua-50 p-7 font-display text-xl font-medium leading-snug tracking-tight text-ink-950 ring-1 ring-aqua-200" data-id="element-190" data-mp="1bn0l53v0za1f">
              &ldquo;Chlorine is outdated. Fusion 44X is the future.&rdquo;
            </blockquote>
          </div>
        </div>
      </div>
    </section>;
}